import { AppData, Lightning } from '@lightningjs/sdk'
import { Column } from '@lightningjs/ui-components'
import { Helper } from '../lib/helper'
import { AppSetup } from '../lib/app-setup'
import PlayerFeedbackFormItem from './player-feedback-form-item'

// In-player feedback form overlay (XFIN-1495).
const PANEL_WIDTH = 867
const FEEDBACK_REASONS = [
    'Start From Beginning After Ads',
    'Stuck In Ads',
    'Freezing After Ads',
    'Seeing A Black Screen',
    'Buffering Before Video Start',
    'Buffering During Video',
    'Buffering After Ads',
    'Video Freeze',
    'Fast-Forward or Rewind Failed',
]

export interface PlayerFeedbackFormOverlayTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Panel: {
        Header: object
        SubHeader: object
        OptionsList: typeof Column
    }
}

export default class PlayerFeedbackFormOverlay extends Lightning.Component<PlayerFeedbackFormOverlayTemplateSpec> {
    static override _template(): Lightning.Component.Template<PlayerFeedbackFormOverlayTemplateSpec> {
        return {
            w: 1920,
            h: 1080,
            rect: true,
            color: 0x00000000,
            Panel: {
                x: (w: any) => w - PANEL_WIDTH,
                w: PANEL_WIDTH,
                h: 1080,
                rect: true,
                color: 0xff0d0d1d,
                alpha: 0.95,
                Header: {
                    x: 50,
                    y: 60,
                    text: {
                        text: 'Send Feedback',
                        fontSize: 40,
                        textColor: 0xffffffff,
                        fontFace: Helper.getFontFamily('Black'),
                    },
                },
                SubHeader: {
                    x: 50,
                    y: 128,
                    text: {
                        text: 'Video Playback',
                        fontSize: 22,
                        textColor: 0xffffffff,
                        fontFace: Helper.getFontFamily('Regular'),
                    },
                },
                OptionsList: {
                    x: 50,
                    y: 175,
                    w: PANEL_WIDTH - 90,
                    h: 810,
                    type: Column,
                    collision: true,
                    clipping: true,
                    style: { itemSpacing: 8 },
                    items: [],
                },
            },
        } as any
    }

    override _init() {
        this.visible = false
        this.alpha = 0
        this._buildList()
    }

    _buildList() {
        const items = [
            {
                type: PlayerFeedbackFormItem,
                w: PANEL_WIDTH - 90,
                h: 60,
                item: { label: 'Cancel' },
                itemIndex: 0,
            },
            ...FEEDBACK_REASONS.map((label, i) => ({
                type: PlayerFeedbackFormItem,
                w: PANEL_WIDTH - 90,
                h: 52,
                item: { label },
                itemIndex: i + 1,
            })),
        ]
        this.tag('Panel.OptionsList')!.items = items
    }

    override _active() {
        const list = this.tag('Panel.OptionsList') as unknown as Column
        if (list) list.selectedIndex = 0
        const { platform } = AppData as AppSetup
        platform?.textToSpeach('Send Feedback, Video Playback')
    }

    override _getFocused(): any {
        return this.tag('Panel.OptionsList')
    }

    override _handleBack() {
        this.close()
        return true
    }

    $ItemHovered(itemIndex: number) {
        const list = this.tag('Panel.OptionsList') as unknown as Column
        if (list) list.selectedIndex = itemIndex
    }

    $ItemSelected(itemIndex: number) {
        if (itemIndex === 0) {
            // Cancel selected
            this.close()
        } else if (itemIndex > 0 && itemIndex <= FEEDBACK_REASONS.length) {
            // Feedback reason selected
            const selectedCategory = FEEDBACK_REASONS[itemIndex - 1]
            this.fireAncestors('$feedbackCategorySelected' as any, selectedCategory)
            this.fireAncestors('$closePlayerFeedbackForm' as any, 'submitted')
        }
    }

    close() {
        this.fireAncestors('$closePlayerFeedbackForm' as any, 'cancelled')
    }
}
